/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Domy_Byty_PozemkyInputs */

const cs_enum_domy_byty_pozemky = /** @type {(inputs: Enum_Domy_Byty_PozemkyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DomyBytyPozemky`)
};

const en_enum_domy_byty_pozemky = /** @type {(inputs: Enum_Domy_Byty_PozemkyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DomyBytyPozemky`)
};

/**
* | output |
* | --- |
* | "DomyBytyPozemky" |
*
* @param {Enum_Domy_Byty_PozemkyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_domy_byty_pozemky = /** @type {((inputs?: Enum_Domy_Byty_PozemkyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Domy_Byty_PozemkyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_domy_byty_pozemky(inputs)
	return cs_enum_domy_byty_pozemky(inputs)
});